import { WidgetAutocheck } from "@redotech/redo-model/widget";
import {
  ExtensionShopifyClient,
  ShopifyAjaxClient,
} from "@redotech/shopify-client/ajax";
import { TapcartClient } from "../shopify";
import { getStorefrontAccessToken } from "../utils";
import { BigcommerceStorefrontClient } from "./bigcommerce-storefront";
import { CommercecloudStorefrontClient } from "./commercecloud-storefront";

export interface CreateExtensionShopifyClientOptions {
  autocheck: WidgetAutocheck;
  onTapcart: boolean;
}

export async function createExtensionShopifyClient(
  autocheck: WidgetAutocheck,
  onTapcart: boolean,
): Promise<ExtensionShopifyClient> {
  if (globalThis.redoStorefront?.type === "bigcommerce") {
    return new BigcommerceStorefrontClient({
      storeUrl: globalThis.redoStorefront.storeUrl!,
      auth: getStorefrontAccessToken(autocheck),
    });
  } else if (globalThis.redoStorefront?.type === "commercecloud") {
    return new CommercecloudStorefrontClient({
      storeUrl: globalThis.redoStorefront.storeUrl!,
    });
  } else if (onTapcart) {
    return new TapcartClient(
      getStorefrontAccessToken(autocheck),
      (globalThis as any).STORE_URL,
      globalThis.Tapcart!,
    );
  } else {
    return ShopifyAjaxClient.fromEnv();
  }
}
